"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.options = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _normal = _interopRequireDefault(require("./_normal.scss"));

var _Divider = _interopRequireDefault(require("./../../molecules/Divider"));

var _reactCssThemr = require("react-css-themr");

var _limitedWidth = _interopRequireDefault(require("../../hoc/limitedWidth"));

var _Boxed = _interopRequireDefault(require("../../hoc/Boxed"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // export const options = questionOptions;


var options = {};
exports.options = options;

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      TextEditor = _ref.TextEditor,
      _ref$ContentWrapper = _ref.ContentWrapper,
      ContentWrapper = _ref$ContentWrapper === void 0 ? 'div' : _ref$ContentWrapper;

  var Question = /*#__PURE__*/function (_React$Component) {
    _inherits(Question, _React$Component);

    var _super = _createSuper(Question);

    function Question(props) {
      var _this;

      _classCallCheck(this, Question);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "renderMediaAnswers", function () {
        var theme = _this.props.theme;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: theme.mediaAnswerWrapper
        }, _this.renderChildren());
      });

      _defineProperty(_assertThisInitialized(_this), "renderChildren", function () {
        var _this$props = _this.props,
            children = _this$props.children,
            theme = _this$props.theme;
        return _react["default"].Children.map(children, function (answer) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: theme.mediaAnswer
          }, answer);
        });
      });

      _defineProperty(_assertThisInitialized(_this), "renderMultipleChoice", function () {
        var _this$props2 = _this.props,
            children = _this$props2.children,
            onClick = _this$props2.onClick;
        return _react["default"].Children.map(children, function (child) {
          return /*#__PURE__*/_react["default"].cloneElement(child, {
            onSubmit: onClick
          });
        });
      });

      _defineProperty(_assertThisInitialized(_this), "renderPlainChildren", function () {
        return _this.props.children;
      });

      _this.questionTypes = {
        media: _this.renderMediaAnswers,
        text: _this.renderPlainChildren,
        form: _this.renderPlainChildren,
        multipleChoice: _this.renderMultipleChoice
      };
      return _this;
    }

    _createClass(Question, [{
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            type = _this$props3.type,
            draft = _this$props3.draft,
            color = _this$props3.color,
            align = _this$props3.align,
            rest = _objectWithoutProperties(_this$props3, ["type", "draft", "color", "align"]);

        return /*#__PURE__*/_react["default"].createElement("div", null, draft && /*#__PURE__*/_react["default"].createElement(TextEditor, _extends({
          draft: draft,
          color: color,
          align: align
        }, rest, {
          boxed: false
        })), /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
          hidden: true
        }), /*#__PURE__*/_react["default"].createElement(ContentWrapper, null, this.questionTypes[type]()));
      }
    }]);

    return Question;
  }(_react["default"].Component);

  Question.displayName = identifier;
  Question.themeShape = {
    mediaAnswer: _propTypes["default"].string.isRequired
  };
  Question.propTypes = {
    type: _propTypes["default"].oneOf(['media', 'text', 'form', 'multipleChoice']).isRequired,
    children: _propTypes["default"].any,
    theme: _propTypes["default"].shape(Question.themeShape),
    draft: _propTypes["default"].object,
    color: _propTypes["default"].string,
    align: _propTypes["default"].oneOf(['center', 'left']),
    isResponsive: _propTypes["default"].bool,
    hasBoxedText: _propTypes["default"].bool
  };
  Question.defaultProps = {
    align: 'center',
    color: 'black',
    isResponsive: true,
    box: {
      top: 'large',
      bottom: 'large',
      left: 'medium',
      right: 'medium'
    }
  };
  var themed = (0, _reactCssThemr.themr)(identifier, _normal["default"])(Question);
  var limited = (0, _limitedWidth["default"])(themed, 'button');
  return (0, _Boxed["default"])(true)(limited);
};

var _default = factory;
exports["default"] = _default;